import { trackCardLight } from '@lib/style/cardLight';
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import css from './SelectableCard.module.scss';

interface SelectableCardProps extends React.HTMLAttributes<HTMLDivElement> {
  isSelected: boolean;
  /** The workspace cards' hover: the card lifts, and a soft light follows the cursor. Its
   *  container must not clip it. */
  liftOnHover?: boolean;
  children: React.ReactNode;
}

export const SelectableCard = forwardRef<HTMLDivElement, SelectableCardProps>(
  ({ isSelected, liftOnHover, children, className, onPointerMove, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={classNames(
          css.selectableCard,
          isSelected && css.selected,
          liftOnHover && css.liftOnHover,
          className,
        )}
        onPointerMove={(e) => {
          if (liftOnHover) trackCardLight(e);
          onPointerMove?.(e);
        }}
        {...props}
      >
        {children}
      </div>
    );
  },
);

SelectableCard.displayName = 'SelectableCard';
